/**
 * ストアフロント向け日本電話番号ユーティリティ（ブラウザ IIFE）
 * 正本ロジック: app/lib/jp-phone.shared.js
 * 配布先: extensions/price-hider/assets/ktob-jp-phone.shared.js（同内容を維持）
 */
(function (global) {
  function digitsOnly(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function canonicalPhoneDigits(rawPhone) {
    if (!rawPhone || String(rawPhone).trim() === "") return "";
    var clean = String(rawPhone).replace(/[-\s()]/g, "");
    if (clean.indexOf("+81") === 0) {
      clean = "0" + clean.slice(3);
    } else if (clean.indexOf("81") === 0 && clean.length >= 11) {
      clean = "0" + clean.slice(2);
    }
    return digitsOnly(clean);
  }

  function formatJapanesePhoneForApi(rawPhone) {
    var digits = canonicalPhoneDigits(rawPhone);
    if (!digits || digits.charAt(0) !== "0") return "";
    return "+81" + digits.slice(1);
  }

  function displayJapanesePhone(rawPhone) {
    if (!rawPhone || String(rawPhone).trim() === "") return "";
    var digits = canonicalPhoneDigits(rawPhone);
    if (digits.charAt(0) !== "0") return String(rawPhone).trim();

    if (/^0[789]0\d{8}$/.test(digits)) {
      return digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
    }
    if (/^03\d{8}$/.test(digits)) {
      return digits.slice(0, 2) + "-" + digits.slice(2, 6) + "-" + digits.slice(6);
    }
    if (/^06\d{8}$/.test(digits)) {
      return digits.slice(0, 2) + "-" + digits.slice(2, 6) + "-" + digits.slice(6);
    }
    if (digits.length === 10) {
      return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6);
    }
    if (digits.length === 11) {
      return digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
    }
    return digits;
  }

  global.ktobJpPhone = {
    displayJapanesePhone: displayJapanesePhone,
    formatJapanesePhoneForApi: formatJapanesePhoneForApi,
  };
})(typeof window !== "undefined" ? window : globalThis);
